var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 37,
    viewBox: "0 0 195 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1246 12.5443L93.6999 13.1019C97.4167 13.4736 101.412 14.4028 101.412 21.8365V31.4073H96.5804V17.7479L91.0051 16.9116C90.0759 16.8187 89.0538 16.6329 88.1246 16.3541V31.4073H83.2927V16.2612H88.0317C85.4299 15.4249 83.2927 13.5665 83.2927 8.17706V5.57527H88.1246V12.5443Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8678 27.04H73.6289V13.009H78.3679V31.4073H72.0492C66.1023 31.4073 63.0359 28.8985 63.0359 22.6727V13.009H67.8678V27.04Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6287 13.009H57.3677V27.04H63.5934V31.4073H61.6421C55.6951 31.4073 52.6287 28.8985 52.6287 22.6727V13.009Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.846 13.009H138.859C144.806 13.009 147.873 15.4249 147.873 21.7435V24.0666H138.859C137.17 24.0666 135.713 23.864 134.492 23.4312V27.04H146.851V31.4073H138.767C132.82 31.4073 129.753 28.9914 129.753 23.4161H134.45C131.403 22.3173 129.846 19.7683 129.846 15.332V13.009ZM143.041 20.071V17.0975H134.585V20.071H143.041Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.965 8.08414C105.965 6.5974 106.988 5.57527 108.474 5.57527C109.961 5.57527 110.983 6.5974 110.983 8.08414C110.983 9.57087 109.961 10.593 108.474 10.593C106.988 10.593 105.965 9.57087 105.965 8.08414Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89 13.009V31.4073H106.058V13.009H110.89Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.258 16.8187H120.089V27.04H126.222V31.4073H124.271C118.324 31.4073 115.258 28.8985 115.258 22.6727V16.8187Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.258 8.64166H120.089V13.009H126.222V17.3762H124.271C118.324 17.3762 115.258 14.8674 115.258 8.64166Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2834 8.17706C28.2834 3.71684 31.9073 0.092921 36.3675 0.092921L46.2172 0L38.133 8.08414V36.8897H23.2657C15.2745 36.8897 8.67706 30.3852 8.67706 22.3011V16.2612H0.5C0.5 11.801 4.12392 8.17706 8.58414 8.17706H8.67706C8.67706 3.71684 12.301 0.092921 16.7612 0.092921H26.6108L18.5267 8.17706H28.2834ZM27.9117 17.0975C26.7037 18.3055 26.7037 20.2568 27.9117 21.4648C29.1197 22.6727 31.071 22.6727 32.279 21.4648L27.9117 17.0975Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.514 12.5443L162.09 13.1019C165.807 13.4736 169.802 14.4028 169.709 21.8365V22.6727C169.709 28.8985 166.643 31.4073 160.696 31.4073C154.749 31.4073 151.683 28.8985 151.683 22.6727V16.2612H156.422C153.82 15.4249 151.683 13.5665 151.683 8.17706V5.57527H156.514V12.5443ZM156.514 27.04H164.97V17.7479L159.395 16.9116C158.466 16.8187 157.444 16.6329 156.514 16.3541V27.04Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.891 8.08414C173.891 6.5974 174.913 5.57527 176.4 5.57527C177.979 5.57527 179.001 6.5974 178.908 8.08414C178.908 9.57087 177.886 10.593 176.4 10.593C174.913 10.593 173.891 9.57087 173.891 8.08414Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.015 8.64166V13.009H194.24V17.3762H192.289C186.342 17.3762 183.276 14.8674 183.276 8.64166H188.015Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.276 16.8187H188.015V27.04H194.24V31.4073H192.289C186.342 31.4073 183.276 28.8985 183.276 22.6727V16.8187Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.908 31.4073H174.077V13.009H178.908V31.4073Z",
    fill: "#0B0B17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebit);
export default __webpack_public_path__ + "static/media/whitebit.99d550c29f463d258f8695aa9382b639.svg";
export { ForwardRef as ReactComponent };